import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    flexGrow: 1,
  },
});

export default useStyles;
